import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    campaignDetails:{
        inventory : [],
        description: "",
        launch_date: null,
        end_date: null,
        status: "",
        campaign_images: []
    },
    modal: false,
    campaignEdit: false,
    campaign: [],
    loading:false,
    activeStatus:[],
    upcomingCampaign:[],
    expiredCampaign:[],
    edit:false,
    searchCampaign:""
}

const campaignReducer = createSlice({
    name: "campaignReducer",
    initialState: initialState,
    reducers: {
        updateCampaignDetails:( state, {type, payload}) =>{
            state.campaignDetails = payload
        },
        updateModal: (state, {  type, payload }) => {
            state.modal = payload
        },
        updateCampaignEdit: (state, { type, payload }) => {
            state.campaignEdit = payload
        },
        updateLoadingCampaigns: (state, { type, payload }) => {
            state.loading = payload
        },
        updateCampaigns: (state, { type, payload }) => {
            state.campaign = payload
        },
        updateActiveStatus: (state, { type, payload }) => {
            state.activeStatus = payload
        },
        updateEdit: (state, { payload }) => {
            state.edit = payload
        },
        updateUpcomingCampaigns: (state, { payload }) => {
            state.upcomingCampaign = payload
        },
        updateExpiredCampaigns: (state, { payload }) => {
            state.expiredCampaign = payload
        },
        updateSearchCampaign: (state, { type, payload }) => {
            state.searchCampaign = payload
        },
    }
})

export const { updateModal,updateSearchCampaign, updateCampaignEdit, updateLoadingCampaigns, updateCampaigns, updateUpcomingCampaigns, updateExpiredCampaigns, updateActiveStatus, updateEdit, updateCampaignDetails } = campaignReducer.actions

export default campaignReducer.reducer;